import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
// import GD from '../../RestAPI/getData';
import cookie from 'react-cookies';
import TagManager from 'react-gtm-module';
import { Modal, ModalBody } from 'reactstrap';
import language from '../../../assets/languages/language';
// import { getDeviceDetails } from "../../../common/deviceDetails";
import {
  Currency,
  examNameAccordingToDB,
  GA4Purchase,
  GTM_ID,
  GTMPurchaseCompleted,
} from '../../../common/constant';
import { getIpAddress } from '../../../common/getIpAddress';
import { examRedirectRoute } from '../../Common/examRedirectRoute';
import OrderLinkInvalid from './OrderLinkInvalid';

/* eslint-disable*/
class CheckoutVerify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      landingSource: 'organic',
      landingSourceName: null,
      username: '',
      email: '',
      amount: '',
      city: '',
      packageID: '',
      userIP: '',
      message_background: 'bg-danger',
      displaytext: 'hide_block',
      orders_discription: '',
      order_price: [],
      loader: true,
      password: '',
      exam: '',
      isLinkInvalid: false,
      discountAmount: 0,
      passwordAlert: false,
      enterPassword: '',
      showDetails: false,
      passwordErrorMessage: '',
      forgotOpenStatus: false,
      isExist: false,
      landingSource: 'organic',
      landingSourceName: null,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      tapfilliate: false,
      stripeCustomerID: '',
      stripeChargeID: '',
      paymentType: ""
    };
    this.login = this.login.bind(this);
    this.password = this.password.bind(this);
    this.onLoginSubmit = this.onLoginSubmit.bind(this);
  }

  async componentDidMount() {
    /*
--------------------------------
  Pixel Integration code start
--------------------------------
*/
    let landingSourceCokkie = cookie.load('utm_source', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (landingSourceCokkie) {
      this.setState({
        landingSource: landingSourceCokkie,
      });
    }
    localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
    let checkTapfilliateRefernce = cookie.load('ref', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (checkTapfilliateRefernce) {
      this.setState({
        landingSource: 'tapfiliate',
        landingSourceName: checkTapfilliateRefernce,
      });
      localStorage.setItem('landingSource', 'tapfiliate');
    }

    localStorage.setItem(
      'landingSourceName',
      checkTapfilliateRefernce ? checkTapfilliateRefernce : null,
    );
    /*
-------------------------------
  Pixel Integration code end
-------------------------------    
    */

    // GD.GetCallAPI("https://geolocation-db.com/json/").then((resp) => {
    //   this.setState({
    //     userIP: resp.IPv4,
    //   });
    // });
    let parsed = this.props.location.query;

    this.updateParsedValue(parsed);

    // api to get ip address
    const result1 = await getIpAddress();
    if (result1) {
      this.setState({
        user_city: result1.city,
        user_country: result1.country,
        user_ip: result1.query,
        userIP: result1.query,
        user_state: result1.region,
        user_continent: result1.continent,
      });
    }
    // const result = getDeviceDetails();
    const data1 = {
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    localStorage.setItem('userData', JSON.stringify(data1));
  }

  getOrderById = async data => {
    const response = await FD.callAPI(
      App_data.backend_api + '/wooCoomerceCheckout/getOrdersbyid',
      data,
    );

    if (response && response.success) {
      const { order_data, stripe_customerID, stripe_chargeID, amount, payment_type } = response.data;
      const orderDataInJSONString = JSON.stringify(order_data);
      const orderDataInJson = JSON.parse(JSON.parse(orderDataInJSONString));
      this.setState({
        orders_discription: orderDataInJson,
        totalAmount: amount,
        order_price: orderDataInJson.all_order_details,
        loader: false,
        showDetails: true,
        tapfilliate: !data.isExist,
        stripeCustomerID: stripe_customerID,
        stripeChargeID: stripe_chargeID,
        paymentType: payment_type
      });
      window.uet_report_conversion(response.data.amount);
      if (!data.isExist) {
        const gtmData = {
          orders_discription: orderDataInJson,
          totalAmount: response.data.amount,
          order_price: orderDataInJson.all_order_details,
          landingSource: response.landingSource,
          landingSourceName: response.landingSourceName,
        };
        this.GTM_Trigger(gtmData);
      }
    }
  };
  /*
  ------------------------
    Update parsed value
  ------------------------
  */
  updateParsedValue = async parsed => {
    if (parsed.email) {
      this.setState({
        email: parsed.email.replace(/^[^\w]+|[^\w]+$/g, ''),
      });
    }

    if (parsed.first_name || parsed.last_name) {
      let value1 = parsed.first_name.replace(/[^A-Z0-9a-z]/gi, '');
      let value2 = parsed.last_name.replace(/[^A-Z0-9a-z]/gi, '');
      let value = value1.concat(' ', value2);
      this.setState({
        username: value,
      });
    }
    if (parsed.product_id) {
      this.setState({
        packageID: parsed.product_id,
      });
    }
    if (parsed.total) {
      this.setState({
        amount: parsed.total,
      });
    }
    if (parsed.city) {
      this.setState({
        city: parsed.city.replace(/[^A-Z0-9a-z]/gi, ''),
      });
    }

    if (parsed.discount_amount) {
      this.setState({
        discountAmount: parsed.discount_amount,
      });
    }

    if (parsed.transaction_id) {
      this.setState({
        stripeChargeID: parsed.transaction_id,
      });
    }

    if (parsed.subscription_id) {
      this.setState({
        subscriptionScheduleID: parsed.subscription_id,
      });
    }

    let IP = '';
    // await GD.GetCallAPI("https://geolocation-db.com/json/").then((resp) => {
    //   IP = resp.IPv4;
    //   this.setState({
    //     userIP: resp.IPv4,
    //   });
    // });
    // ── payment_type (#273) ──────────────────────────────────────────────
    // WordPress redirects pass `payment_method=PayPal` or `payment_method=Stripe`
    // (capitalised) in the URL. The legacy LMS code dropped this entirely,
    // so PayPal orders ended up persisted as `payment_type='stripe'` and the
    // PayPal Capture ID landed in `stripe_chargeID`. Forward a normalised
    // `payment_type` so the backend writes the right columns.
    const rawMethod = String(parsed.payment_method || '').toLowerCase();
    const paymentType = rawMethod === 'paypal' ? 'paypal' : 'stripe';
    var data = {
      username: parsed.first_name
        .replace(/[^A-Z0-9a-z]/gi, '')
        .concat(' ', parsed.last_name.replace(/[^A-Z0-9a-z]/gi, '')),
      email: parsed.email.replace(/^[^\w]+|[^\w]+$/g, ''),
      landingSource: this.state.landingSource,
      landingSourceName: this.state.landingSourceName,
      packageID: parsed.product_id,
      city: parsed.city.replace(/[^A-Z0-9a-z]/gi, ''),
      amount: parsed.total,
      userIP: IP,
      discountAmount: parsed.discount_amount ? parsed.discount_amount : 0,
      // WP is the source of truth for the partner/sale-adjusted discount %.
      // LMS just forwards. Falls back to 0 when WP doesn't send the param.
      percent_discount: parsed.percent_discount ? Number(parsed.percent_discount) : 0,
      stripeChargeID: parsed.transaction_id,
      subscriptionScheduleID: parsed.subscription_id,
      customerId: parsed.customerId,
      payment_type: paymentType,
      // Wallet/Link metadata forwarded by the WP-Stripe plugin (see proposal
      // in docs/integrations/stripe-wallets.md). Both fields are optional —
      // legacy WP builds that don't send them keep working unchanged.
      walletType: parsed.wallet_type || null,
      paymentIntentId: parsed.payment_intent_id || null,
    };
    FD.callAPI(App_data.backend_api + '/wooCoomerceCheckout/signup', data).then(async resp => {
      if (resp.success) {
        if (!resp.isExist) {
          this.setState({
            password: resp.password,
            exam: resp.exam,
            discountAmount: parsed.discount_amount ? parsed.discount_amount : 0,
          });

          let examIdArray = [];
          examIdArray = resp.plans.map(plan => {
            return plan.exam_id;
          });
          var examData = JSON.stringify(examIdArray);
          data['examData'] = examData;
          // Gate (#273): Stripe path requires a customerId; PayPal path
          // requires the transaction (capture) ID. WordPress's PayPal flow
          // doesn't supply a customerId we can use.
          const canProceed = data.payment_type === 'paypal'
            ? !!data.stripeChargeID
            : !!data.customerId;
          if (canProceed) {
            await FD.callAPI(App_data.backend_api + '/wooCoomerceCheckout/updateOrder', data).then(
              async respOrder => {
                if (respOrder.success) {
                  if (respOrder.isOrderAlreadyExist) {
                    this.setState({
                      loader: false,
                      isLinkInvalid: true,
                    });
                  } else {
                    this.getOrderById(respOrder.orderData);
                  }
                }
              },
            );
          } else {
            this.setState({
              loader: false,
              isLinkInvalid: true,
            });
          }
        } else if (resp.isExist) {
          this.setState({
            isExist: true,
            plans: resp.plans,
            exam: resp.userData.exam,
          });
          let examIdArray = [];
          examIdArray = resp.plans.map(plan => {
            return plan.exam_id;
          });
          var examData = JSON.stringify(examIdArray);
          if (resp.userData.exam_selected !== '') {
            var array1_new = examIdArray;
            var array2_old = JSON.parse(resp.userData.exam_selected);
            var array3_store = array1_new.concat(array2_old);
            var unique_exam = array3_store.filter(function(elem, index, self) {
              return index === self.indexOf(elem);
            });
            examData = JSON.stringify(unique_exam);
          }

          let idArray = [];
          idArray = resp.plans.map(plan => {
            return plan.id;
          });
          var packageData = JSON.stringify(idArray);
          if (resp.userData.exam_package !== '') {
            var array1_new = idArray;
            var array2_old = JSON.parse(resp.userData.exam_package);

            var array3_store = array1_new.concat(array2_old);
            var unique_exam = array3_store.filter(function(elem, index, self) {
              return index === self.indexOf(elem);
            });
            packageData = JSON.stringify(unique_exam);
          }

          var updateorderData = {
            ...data,
            storage_valueofExam: examData,
            storage_valueofPlan: packageData,
            orderData: resp.plans,
          };
          // Same gate (#273) as the new-user branch above.
          const canProceedExisting = updateorderData.payment_type === 'paypal'
            ? !!updateorderData.stripeChargeID
            : !!updateorderData.customerId;
          if (canProceedExisting) {
            await FD.callAPI(
              App_data.backend_api + '/wooCoomerceCheckout/updateExistingUserOrder',
              updateorderData,
            ).then(async respOrder => {
              if (respOrder.success) {
                if (respOrder.isOrderAlreadyExist) {
                  this.setState({
                    loader: false,
                    isLinkInvalid: true,
                  });
                } else {
                  this.getOrderById(respOrder.orderData);
                }
              }
            });
          } else {
            this.setState({
              loader: false,
              isLinkInvalid: true,
            });
          }
        }
      }
    });
  };

  /*
  ----------
    Login 
  ----------
  */
  login = () => {
    const { exam, isExist, email, password } = this.state;

    if (isExist) {
      this.password();
    }
    const loginData = { idname: email, password };

    FD.callAPI(`${App_data.backend_api}/wooCoomerceCheckout/login`, loginData).then(response => {
      if (!response.success) return;

      const { loginID, token, exam_details } = response;
      const { CFA, CFA_LEVEL_1_2025 } = examNameAccordingToDB;

      const selectedExam = exam_details || (exam.startsWith(CFA) ? CFA_LEVEL_1_2025 : exam);
      localStorage.setItem('loginID', loginID);
      localStorage.setItem('localstorageval', JSON.stringify({ token, idname: email }));
      localStorage.setItem('selectedmenu', selectedExam);

      const examRoute = examRedirectRoute[(exam_details || exam).toLowerCase()];
      browserHistory.push({ pathname: examRoute });
    });
  };

  /*
  ------------------
    Password model
  ------------------
  */
  password = () => {
    if (this.state.passwordAlert) {
      this.setState({
        forgotOpenStatus: false,
        passwordAlert: !this.state.passwordAlert,
        message: '',
        passwordErrorMessage: '',
      });
    }
    this.setState({
      passwordAlert: !this.state.passwordAlert,
      message: '',
      passwordErrorMessage: '',
    });
  };

  /*
  -------------------------
    Update password value
  -------------------------
  */
  updatePassword = e => {
    this.setState({
      enterPassword: e.target.value,
      passwordErrorMessage: '',
    });
  };

  /*
  ----------------------
    Login form submit 
  ----------------------
  */
  onLoginSubmit = event => {
    event.preventDefault();
    const { enterPassword, email } = this.state;
    if (enterPassword == '') {
      this.setState({
        passwordErrorMessage: `${language.LC().Password_is_Required}`,
        displaytext: 'show_block',
      });
      return;
    }
    this.setState({
      passwordErrorMessage: '',
      displaytext: 'hide_block',
    });
    var data = { idname: email, password: enterPassword };
    FD.callAPI(App_data.backend_api + '/wooCoomerceCheckout/credentialsCheck', data).then(resp => {
      if (resp.success) {
        this.setState({
          isExist: false,
          password: enterPassword,
        });
        this.login();
      } else {
        this.setState({
          passwordErrorMessage: resp.message,
          enterPassword: '',
          displaytext: 'show_block',
        });
      }
    });
  };

  /*
---------------------
    Forgot password 
---------------------
*/
  handleForgot = () => {
    const { forgotOpenStatus } = this.state;
    var data = { idname: this.state.email };
    FD.callAPI(App_data.backend_api + '/wooCoomerceCheckout/forgetPassword', data).then(resp => {
      if (resp.success) {
        this.setState({
          forgotOpenStatus: true,
          message: '',
          passwordErrorMessage: '',
        });
      }
    });
  };
  /*
  -------------------------------------------------------
    For GTM trigger it's fired when  package purchased
  -------------------------------------------------------
  */
  GTM_Trigger = data => {
    var array = [];
    for (let i = 0; i < data.order_price.length; i++) {
      array.push({
        exam: data.order_price[i].exam_name,
        packageType: data.order_price[i].package_type,
        price: data.order_price[i].price,
      });
    }
    const tagManagerArgs = {
      gtmId: GTM_ID,
      dataLayer: {
        event: GTMPurchaseCompleted,
        eventOptions: {
          orderID: JSON.stringify(data.orders_discription.order_id),
          paymentOption: 'card',
          cart: array,
          cartTotal: data.totalAmount,
        },
        userName: data.orders_discription.username,
        userEmail: data.orders_discription.idname,
        source: data.landingSource,
        value: data.totalAmount,
        currency: Currency,
        affiliateName: data.landingSourceName,
        price: data.totalAmount,
        value: data.totalAmount,
        currency: Currency,
      },
    };
    TagManager.initialize(tagManagerArgs);

    // ******************** For purchase event on GA4 **************** //

    const tagManagerArgsGA4 = {
      gtmId: GTM_ID,
      dataLayer: {
        event: GA4Purchase,
        eventOptions: {
          orderID: JSON.stringify(data.orders_discription.order_id),
          paymentOption: 'card',
          cart: array,
          cartTotal: data.totalAmount,
        },

        transaction_id: JSON.stringify(data.orders_discription.order_id),
        value: data.totalAmount,
        currency: Currency,
        affiliation: data.landingSourceName,
        items: array,
        revenue_value: data.totalAmount,
        userName: data.orders_discription.username,
        userEmail: data.orders_discription.idname,
        source: data.landingSource,
      },
    };
    TagManager.initialize(tagManagerArgsGA4);
  };

  render() {
    const {
      totalAmount,
      order_price,
      orders_discription,
      loader,
      discountAmount,
      passwordAlert,
      email,
      enterPassword,
      passwordErrorMessage,
      showDetails,
      forgotOpenStatus,
      tapfilliate,
      stripeCustomerID,
      stripeChargeID,
      isLinkInvalid,
      paymentType
    } = this.state;

    /*
    --------------------------
      Tapfilliate code
    --------------------------
    */
    let tapFiliateCount = 0;
    if (tapfilliate) {
      <script src='https://script.tapfiliate.com/tapfiliate.js' type='text/javascript' async>
        <script type='text/javascript'>
          {tapFiliateCount++}
          {function(t, a, p) {
            (t.TapfiliateObject = a),
              (t[a] =
                t[a] ||
                function() {
                  (t[a].q = t[a].q || []).push(arguments);
                });
          }}
          )({(window, 'tap')});
          {
            (window.tap('create', '14886-4db9dd', {
              integration: 'stripe',
            }),
            window.tap('conversion', stripeChargeID, totalAmount, {
              customer_id: stripeCustomerID,
            }))
          }
        </script>
      </script>;
    }

    return (
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper'>
            <img src={App_data.frontend_url + '/img/logo1.png'} alt='' width='200' />
          </div>
        </div>

        {loader ? (
          <div>
            <div className='loader_box checkout-message'>
              Your payment is being processed. please do not close this page.
              <div className='sk-circle'>
                <div className='sk-circle1 sk-child' />
                <div className='sk-circle2 sk-child' />
                <div className='sk-circle3 sk-child' />
                <div className='sk-circle4 sk-child' />
                <div className='sk-circle5 sk-child' />
                <div className='sk-circle6 sk-child' />
                <div className='sk-circle7 sk-child' />
                <div className='sk-circle8 sk-child' />
                <div className='sk-circle9 sk-child' />
                <div className='sk-circle10 sk-child' />
                <div className='sk-circle11 sk-child' />
                <div className='sk-circle12 sk-child' />
              </div>
            </div>
          </div>
        ) : null}
        {isLinkInvalid && <OrderLinkInvalid />}
        {showDetails ? (
          <div className='row justify-content-center'>
            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
              <div className='card-group mb-0'>
                <div className='card p-2  '>
                  <div className='card-block'>
                    <h4> {language.LC().THANK_YOU_FOR_YOUR_ORDER}</h4>
                    <p>*You will also receive confirmation of your purchase via email</p>
                  </div>
                  <div className='row'>
                    <div className='col-xs-12 col-sm-6 col-md-7 margin_bottom_10'>
                      <div className='table-responsive thankyou_tb'>
                        <table className='table cart_table '>
                          <thead>
                            <tr>
                              <th>{language.LC().PACKAGE}</th>
                              <th>{language.LC().PRICE}</th>
                              {discountAmount !== 0 ? <th>{language.LC().DISCOUNT}</th> : <th />}
                            </tr>
                          </thead>
                          {order_price && order_price.length > 0
                            ? order_price.map((packageDetail, index) => (
                                <tbody key={index}>
                                  <tr className='package-heading'>
                                    <td width='60%'>
                                      {packageDetail.exam_name +
                                        ' (' +
                                        packageDetail.package_type +
                                        ') '}
                                    </td>
                                    <td width='20%'>${packageDetail.price}.00</td>
                                    {discountAmount !== 0 ? (
                                      <td width='20%'>${discountAmount}</td>
                                    ) : (
                                      <td width='20%' />
                                    )}
                                  </tr>
                                </tbody>
                              ))
                            : null}
                          <tfoot>
                            <tr>
                              <td>
                                <strong>{language.LC().TOTAL}</strong>
                              </td>

                              <td>${totalAmount ? totalAmount.toFixed(2) : null}</td>
                              <td />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div className='col-xs-12 col-sm-6 col-md-5 margin_bottom_10'>
                      <div className='table-responsive thankyou_tb'>
                        <table className='table cart_table'>
                          <tbody>
                            <tr>
                              <td>
                                <strong>{language.LC().ORDER_ID} :</strong>
                              </td>
                              <td>{orders_discription.order_id}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{language.LC().NAME} :</strong>
                              </td>
                              <td>{orders_discription.username}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{language.LC().PAYMENT_METHOD} :</strong>
                              </td>
                              <td>{paymentType}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{language.LC().EMAIL} :</strong>
                              </td>
                              <td>{orders_discription.idname}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10 m-0 d-flex justify-content-center'>
                      <button className='btn btn-primary pointer_class' onClick={this.login}>
                        {' '}
                        {language.LC().START_STUDY}{' '}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {showDetails ? (
          <blockquote className='footer-blockquote'>
            <p>{language.LC().FOOTER_MESSAGE}</p>
          </blockquote>
        ) : null}

        <Modal
          isOpen={passwordAlert}
          toggle={this.password}
          className='forgot-modal'
          // backdrop="static"
        >
          <ModalBody>
            <div className={'forgot-block'}>
              <div className='text-center foget-password-img'>
                <img src={App_data.frontend_url + '/img/forget-password.png'} alt='' />
              </div>
              {!forgotOpenStatus ? (
                <div>
                  <div className='text-center heading foget-password-heading'>
                    {language.LC().LOGIN}
                  </div>
                  <form onSubmit={this.onLoginSubmit}>
                    <div className='form-group forget-password-value'>
                      <input
                        type='text'
                        className='form-control '
                        placeholder='Email'
                        value={email}
                        disabled
                      />

                      <br />
                      <input
                        type='password'
                        className='form-control '
                        placeholder='Please enter your password'
                        value={enterPassword}
                        onChange={this.updatePassword}
                      />
                      <p className={this.state.displaytext + ' text-danger'}>
                        {passwordErrorMessage}
                      </p>
                    </div>
                    <button className='btn forgot-button btn-block pointer_class'>
                      {language.LC().SUBMIT}
                    </button>
                    <div className='forgot-password pointer_class' onClick={this.handleForgot}>
                      {' '}
                      {language.LC().FORGOT_PASSWORD}
                    </div>
                  </form>
                </div>
              ) : (
                <div>
                  <div className='text-center heading foget-password-heading'>
                    {language.LC().FORGOT_PASSWORD}
                  </div>{' '}
                  <div className={'success-block'}>
                    <div className='text-center foget-password-img'>
                      <img src={App_data.frontend_url + '/img/check.png'} alt='' />
                    </div>
                    <div className='text-center heading foget-password-heading'>
                      {language.LC().CHECK_YOUR_EMAIL}
                    </div>
                    <p className='success-text foget-password-text forget-password-value'>
                      {language.LC().RESTE_PASSWORD_LINK}{' '}
                    </p>
                    <button
                      className='btn resend-button btn-block pointer_class'
                      onClick={this.handleForgot}
                    >
                      {language.LC().RESEND_EMAIL}{' '}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CheckoutVerify;



// WEBPACK FOOTER //
// ./src/views/Pages/CheckoutVerify/CheckoutVerify.js